import { Stack } from '@mui/material'
import { ComponentProps, FC } from 'react'
import ReactCardFlip, { ReactFlipCardProps } from 'react-card-flip'
import { Icons, ItemImageArea, ItemImageAreaSkeleton } from 'utoniq-ui'

import { Card, Maybe } from '@/clients/utoniq-core/schema'

export type ItemReversibleThumbnail = {
  loading: boolean
  imageAreaProps: Omit<
    ComponentProps<typeof ItemImageArea>,
    'src' | 'onClick'
  > & {
    thumbnail?: Maybe<Card>
    onClick?: () => void
  }
  flipProps: Omit<ReactFlipCardProps, 'children'>
  btnPlay?: {
    type: 'front' | 'back'
    onClick: () => void
  }
}
/**
 * @description
 * 回転できるアイテムイメージコンポーネント
 * ref: https://github.com/AaronCCWong/react-card-flip
 */
export const ItemReversibleThumbnail: FC<ItemReversibleThumbnail> = ({
  loading,
  imageAreaProps,
  flipProps,
  btnPlay,
}) => {
  return (
    <ReactCardFlip {...flipProps}>
      {
        // front image
        loading ? (
          <ItemImageAreaSkeleton size={imageAreaProps.size} />
        ) : (
          <Stack>
            <ItemImageArea
              {...imageAreaProps}
              src={
                imageAreaProps?.thumbnail?.front?.mediumUri ??
                imageAreaProps?.thumbnail?.front?.uri ??
                ''
              }
            />
            {btnPlay?.type === 'front' && (
              <Icons.Play
                onClick={btnPlay?.onClick}
                fontSize="large"
                sx={{
                  zIndex: 0,
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: 'white',
                }}
              />
            )}
          </Stack>
        )
      }
      {
        // back image
        loading ? (
          <ItemImageAreaSkeleton size={imageAreaProps.size} />
        ) : (
          <Stack>
            <ItemImageArea
              {...imageAreaProps}
              src={
                imageAreaProps?.thumbnail?.back?.mediumUri ??
                imageAreaProps?.thumbnail?.back?.uri ??
                // 裏面のデータがなければ、フロントのデータを表示する
                imageAreaProps?.thumbnail?.front?.mediumUri ??
                imageAreaProps?.thumbnail?.front?.uri ??
                ''
              }
            />
            {btnPlay?.type === 'back' && (
              <Icons.Play
                fontSize="large"
                onClick={btnPlay?.onClick}
                sx={{
                  zIndex: 0,
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: 'white',
                }}
              />
            )}
          </Stack>
        )
      }
    </ReactCardFlip>
  )
}
